<template>
    <div>
      <!-- <TemplateSide v-if="sidebarVisible"/> -->
      <router-view />
    </div>
</template>

<script>
// import TemplateSide from "@/components/Template/TemplateSide";
// import helper from '@/components/Utility/Helper'

export default {
  name: 'App',
  updated() {
    // TODO remove any modal backdrop in case of hot reload/redirect
    $('.modal-backdrop').remove();
  },
  // components: {
    // TemplateSide
  // },
  // data() {
  //   return {
  //     sidebarVisible: true
  //   }
  // },
  // watch: {
  //   '$route' (to, from) {
  //     this.setSidebarState();
  //   }
  // },
  // mounted: function () {
  //   this.setSidebarState();
  // },
  // methods: {
  //   setSidebarState() {
  //     if(this.$route.path === '/login') {
  //       this.sidebarVisible = false;
  //     } else {
  //       this.sidebarVisible = true;

  //       $('ul.nav li.active').removeClass('active')
  //       $('ul.nav ul.in').removeClass('in')
  //       helper.setSidebar(window.location);

  //       // try {
  //       //   $("#side-menu").metisMenu('dispose');
  //       // } catch(e) {
  //       // }
  //       // $('#side-menu').metisMenu();
  //     }
  //   }
  // },
}

</script>



// WEBPACK FOOTER //
// src/App.vue